import PropTypes from 'prop-types';

import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import rightKeySVG from '@plone/volto/icons/right-key.svg';

export const filterAndSortEspecialitats = (items, locale = 'ca') =>
  [...(items || [])]
    .filter((item) => item['@type'] === 'csjespecialitats')
    .sort((a, b) => a.title.localeCompare(b.title, locale));

const EspecialitatsList = ({
  items,
  isEditMode = false,
  editPreview = false,
  locale = 'ca',
}) => {
  const linkDisabled = isEditMode || editPreview;
  const sorted = filterAndSortEspecialitats(items, locale);

  return (
    <ul className="especialitats-list">
      {sorted.map((item) => (
        <ConditionalLink
          key={item['@id']}
          item={item}
          condition={!linkDisabled}
        >
          <li className="especialitats-item">
            <span className="especialitats-item-title">{item.title}</span>
            <Icon
              name={rightKeySVG}
              size="18px"
              className="especialitats-item-chevron"
              ariaHidden
            />
          </li>
        </ConditionalLink>
      ))}
    </ul>
  );
};

EspecialitatsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isEditMode: PropTypes.bool,
  editPreview: PropTypes.bool,
  locale: PropTypes.string,
};

EspecialitatsList.defaultProps = {
  items: [],
  isEditMode: false,
  editPreview: false,
  locale: 'ca',
};

export default EspecialitatsList;
